
export const ADDRESS = process.env.NODE_ENV === 'production' ? '/graphql': 'http://localhost:8082/graphql'


